import * as Data from "../../Data";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";

export const IsPolicyExpired = (endDate: Date): boolean => {
    const date = new Data.CDateTZLess(endDate);
    return !!(new Data.CDateTZLess(new Date()).IsGreaterOrEqualThan(date) && date.IsGreaterThan(new Data.CDateTZLess(new Date()).AddDays(-30)));
};

export const IsPolicyExpiring = (endDate: Date): boolean => {
    const date = new Data.CDateTZLess(endDate);
    return !!(date.IsGreaterThan(new Data.CDateTZLess(new Date())) && new Data.CDateTZLess(new Date()).AddDays(30).IsGreaterOrEqualThan(date));
};

export const GetURLRCP = (dato: Dati.CDatiPolizzaGenerale): string => {
    let url = "";
    if (dato.ID_AnagContraente == 0) {
        switch (dato.ID_TipoPolizzaStato) {

            case Glob.Tipi_PS_Preventivo:
            case Glob.Tipi_PS_ConsolidataSottoscrittore:
                url = "/rcpcomparatore/" + dato.ID_Polizza;
                break;
            case Glob.Tipi_PS_InRinnovo:
            case Glob.Tipi_PS_InRinnovoConsolidata:
            case Glob.Tipi_PS_InRinnovoApprovata:
            case Glob.Tipi_PS_EmessaRinnovata:
            case Glob.Tipi_PS_EmessaRinnovataQ:
                url = "/rcppolizzarinnovo/" + dato.ID_Polizza;
                break; 
            default:
                url = "/rcppolizza/" + dato.ID_Polizza;
        }
    } else {
        switch (dato.ID_TipoPolizzaStato) {

            case Glob.Tipi_PS_Preventivo:
            case Glob.Tipi_PS_ConsolidataSottoscrittore:
                url = "/anagrafica/" + dato.ID_AnagContraente + "/rcpcomparatore/" + dato.ID_Polizza;
                break;
            case Glob.Tipi_PS_InRinnovo:
            case Glob.Tipi_PS_InRinnovoConsolidata:
            case Glob.Tipi_PS_InRinnovoApprovata:
            case Glob.Tipi_PS_EmessaRinnovata:
            case Glob.Tipi_PS_EmessaRinnovataQ:
                url = "/anagrafica/" + dato.ID_AnagContraente + "/rcppolizzarinnovo/" + dato.ID_Polizza;
                break;
            default:
                url = "/anagrafica/" + dato.ID_AnagContraente + "/rcppolizza/" + dato.ID_Polizza;
        }
    }
    return url;
};

export const GetURL = (dato: Dati.CDatiPolizzaGenerale): string => {
    if ((dato.ID_TipoProdotto > 99 && dato.ID_TipoProdotto != 101 && dato.ID_TipoProdotto < 128) 
        || dato.ID_TipoProdotto == 26 || dato.ID_TipoProdotto == 27 || dato.ID_TipoProdotto == 131|| dato.ID_TipoProdotto == 157)
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/polizzaneutra/" + dato.ID_Polizza;
    }
    if (dato.ID_TipoRamo == Glob.TipiRami_CAR)
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/polizzacar/" + dato.ID_Polizza;
    }
    if (dato.ID_TipoRamo == Glob.TipiRami_RCP) {
        return GetURLRCP(dato);
    } else if (dato.ID_AnagContraente > 0 && dato.ID_FideAffidamento > 0 && dato.ID_Polizza > 0) {
        return "/anagrafica/" + dato.ID_AnagContraente + "/fideaffidamento/" + dato.ID_FideAffidamento + "/fidepolizza/" + dato.ID_Polizza;
    } else
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/fidepolizza/" + dato.ID_Polizza;    
    }
    return "#";
};

export const GetURLRinnovata = (dato: Dati.CDatiPolizzaGenerale): string => {
    if (dato.ID_TipoProdotto > 99 && dato.ID_TipoProdotto != 101)
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/polizzaneutra/" + dato.ID_PolizzaRinnovata;
    }
    if (dato.ID_TipoRamo == Glob.TipiRami_CAR)
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/polizzacar/" + dato.ID_PolizzaRinnovata;
    }
    if (dato.ID_TipoRamo == Glob.TipiRami_RCP) {
        return "/anagrafica/" + dato.ID_AnagContraente + "/rcppolizza/" + dato.ID_PolizzaRinnovata;
    } else if (dato.ID_AnagContraente > 0 && dato.ID_FideAffidamento > 0 && dato.ID_PolizzaRinnovata > 0) {
        return "/anagrafica/" + dato.ID_AnagContraente + "/fideaffidamento/" + dato.ID_FideAffidamento + "/fidepolizza/" + dato.ID_PolizzaRinnovata;
    } else
    {
        return "/anagrafica/" + dato.ID_AnagContraente + "/fidepolizza/" + dato.ID_PolizzaRinnovata;
    }
    return "#";
};


// WEBPACK FOOTER //
// ./src/inar2/helpers/Policies.ts